import React from 'react';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import WorkOrdersGrid from '../shared/WorkOrdersGrid';
import useWorkOrders from '../hooks/useWorkOrders';

const WorkOrderPage: React.FC = () => {
  const { data, status } = useWorkOrders();
  return (
    <WorkOrdersGrid data={data?.index} status={status} />
  );
};

export default withAuthenticationRequired(WorkOrderPage);
